import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadLists,
} from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
replaceInChain(chain, LoadLists, props => {
    const state = props.getState();
    const getWishListsParameter = state.components.addToListModal.getWishListsParameter;
    const session = state.context.session;
    if (
        props.parameter.modalIsOpen &&
        (session.isAuthenticated || session.rememberMe) &&
        !getWishListsDataView(state, getWishListsParameter).value
    ) {
        props.dispatch(loadWishLists(getWishListsParameter));
    }
});
